import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { VAT_PAYER_NAME } from './RadioGroupVatPayer';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNERSHIP_TYPE = {
  PRIVATE: 'private',
  COMPANY: 'company',
} as const;

export const OWNERSHIP_TYPE_NAME = 'ownership_type';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupOwnershipType: FC<Props> = ({
  name = OWNERSHIP_TYPE_NAME,
}) => {
  const { i18n } = useLingui();
  const { control, setValue } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy nieruchomość jest wykorzystywana w ramach prowadzenia działalności gospodarczej?'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              onChange={(value) => {
                field.onChange(value);
                // shouldUnregister: false keeps the hidden VAT answer in form data,
                // explicit null clears the value already saved in CRM
                if (value !== OWNERSHIP_TYPE.COMPANY) {
                  setValue(VAT_PAYER_NAME, null);
                }
              }}
            >
              <RadioItem
                data-testid={`${name}-radio-group-${OWNERSHIP_TYPE.COMPANY}`}
                value={OWNERSHIP_TYPE.COMPANY}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${OWNERSHIP_TYPE.PRIVATE}`}
                value={OWNERSHIP_TYPE.PRIVATE}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
